import { ParameterInfos } from 'ut-business/parameter';

export const awsParameters: Record<string, ParameterInfos> = {
  awsEnabled: {
    inspectionMode: {
      setup: {
        isReadOnly: false,
      },
      inspection: {
        isReadOnly: true,
      },
      pause: {
        isReadOnly: true,
      },
      analysis: {
        isReadOnly: true,
      },
    },
  },
};
